import * as React from 'react';
import PropTypes from 'prop-types';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Badge,
    Divider,
    TextField,
    IconButton,
    Table,
    TableBody,
    TableHead,
    TableCell,
    TableContainer,
    TableRow,
    FormHelperText,
    FormControl
} from '@mui/material/';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import MyButton from '../../component/MuiReusableComponents/MuiButton/buttonMUI';
import { useForm, FormProvider } from 'react-hook-form';
import MaterialUIPickers from '../../component/MuiReusableComponents/MuiFormComponents/DatePicker/date.picker.component';
import { useDispatch, useSelector } from 'react-redux';
import SearchIcon from '@mui/icons-material/Search';

import SimpleCollapse from '../../component/MuiReusableComponents/MuiCollapse/collapseMUI';
import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import MyTextField from '../../component/MuiReusableComponents/MuiFormComponents/TextField.Component';
import MySelect from '../../component/MuiReusableComponents/MuiFormComponents/Select.component';
import CheckIcon from '@mui/icons-material/Check';
import FormHeadFilter from '../../component/MuiReusableComponents/FormHeadText/formHeadText';
import { NumericFormat } from 'react-number-format';
import {
    allPaymentsDataSelector,
    startAddNewPayment,
    startPaymentListByPageIndex,
    startDeletePayment,
    startFilterpaymentsListData,
    setPage,
    setRowsPerPage,
    createPramsPaymentSelector,
    setCreatePrams,
    singleClientPaymentsDetailSelector,
    startClientPaymentsDataNoLoad
} from '../../store1/payment/paymentData.slice.selector';
import {
    FilterDataSelector,
    allClientsDataSelector,
    startAllClientsData,
    startFilterData
} from '../../store1/client data/client.data.slice.selector';
import { useLocation, useNavigate } from 'react-router-dom';
import DeletePopup from '../../component/DeletePopup/deletePopup';

import { startLookUpDetailsByLookupId1, lookUpDetailByIdSelector } from '../../store1/lookupDetails data/lookupDetailsSlice.selector';

import DeleteIcon from '@mui/icons-material/Delete';
import { ClearAll, Edit } from '@mui/icons-material';
import PopupDialogs from '../../component/MuiReusableComponents/MuiPopupDialog/new-popup';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import PaymentTable from './customPaymentTable';
import { allInvoicesSelector, startFilterInvoicesListData } from '../../store1/invoice data/invoiceData.slice.selector';

////Needed Component
const FormHead = ({ headText, required, sx }) => {
    return (
        <>
            <Typography sx={{ paddingTop: '8px', marginRight: '10px', width: '38%' }} variant="subtitle1" gutterBottom>
                <span
                    style={{
                        ...sx,
                        fontWeight: 'bold',
                        paddingBottom: '3px',
                        color: 'rgba(48, 51, 107,1.0)'
                    }}
                >
                    {headText}
                </span>
                {required && <span style={{ color: 'red' }}>*</span>}:
            </Typography>
        </>
    );
};

////Needed Component
const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props;

    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value
                    }
                });
            }}
            thousandSeparator
            prefix=""
            // suffix=" /-"
        />
    );
});

NumberFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
};

////Needed Component
const FilterAndSearchBox = ({ infoData }) => {
    const {
        setCollapseFilterControl,
        selectClientArray,
        sortedSelectClientArray,
        setFilteredRows,
        rows,
        setFilterStatus,
        filterStatus,
        modeOfPaymentArray
    } = infoData;
    const modeOfPaymentArray12 = [{ name: 'All', value: 0 }, ...modeOfPaymentArray];
    const selectClientArray2 = [...selectClientArray];

    const sortedSelectClientArray2 = selectClientArray2.slice().sort((a, b) => a.name.localeCompare(b.name));

    const dispatch = useDispatch();
    React.useEffect(() => {
        if (!filterStatus) {
            form.reset({
                startDateValue: null,
                endDateValue: null,
                clientName: 0,
                modeOfPayment: 0,
                currency_type: ''
            });
        }
    }, [filterStatus]);
    const form = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onChange',
        defaultValues: {
            clientName: 0,
            startDateValue: null,
            endDateValue: null,
            modeOfPayment: 0,
            currency_type: ''
        }
    });

    const formatDate = (date) => {
        const year = date?.getFullYear();
        const month = String(date?.getMonth() + 1).padStart(2, '0');
        const day = String(date?.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    const onSubmit = (data) => {
        const mappedData = {
            payment_mode: data.modeOfPayment,
            clientName: data.clientName,
            currency_type: data.currency_type,
            startDateValue: data.startDateValue ? formatDate(data.startDateValue) : '',
            endDateValue: data.endDateValue ? formatDate(data.endDateValue) : ''
        };
        dispatch(startFilterpaymentsListData(mappedData));

        dispatch(startFilterData(mappedData));
    };

    const handleReset = () => {
        setFilterStatus(false);
        setFilteredRows(rows);
        form.reset({
            startDateValue: null,
            endDateValue: null,
            clientName: 0,
            modeOfPayment: 0,
            currency_type: ''
        });
        dispatch(
            startFilterData({
                clientName: '',
                invoiceStatus: 0,
                invoiceNumber: '',
                startDateValue: '',
                endDateValue: ''
            })
        );
        dispatch(setPage(1));
        dispatch(setRowsPerPage(10));
        dispatch(startPaymentListByPageIndex());
    };

    return (
        <Paper sx={{ borderRadius: '10px', marginBottom: '15px', bgcolor: '#dff9fb87' }}>
            <Box
                sx={{
                    textAlign: 'right',
                    display: 'flex',
                    flexDirection: 'row',
                    paddingTop: '10px',
                    bgcolor: '#ffeaa786'
                }}
            >
                <Typography
                    sx={{
                        width: '100%',
                        textAlign: 'left',
                        fontWeight: 'bold',
                        paddingLeft: '25px'
                    }}
                    variant="subtitle1"
                    gutterBottom
                >
                    Filter
                </Typography>
            </Box>
            <Divider />
            <FormProvider {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                    <Box
                        sx={{
                            width: '100%',
                            padding: '15px',
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-around'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <FormHeadFilter headText="Select Clients " />
                            <MySelect
                                fullWidth
                                size="small"
                                name="clientName"
                                sx={{ width: '250px' }}
                                rules={{
                                    required: 'Required !'
                                }}
                                defaultItem={{ name: 'All', value: 0 }}
                                items={[...sortedSelectClientArray2]}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <FormHeadFilter headText="Date " />
                            <Box sx={{ display: 'flex' }}>
                                <MaterialUIPickers
                                    size="small"
                                    views={['year', 'month', 'day']}
                                    name="startDateValue"
                                    placeholder=" Enter Database Column Name"
                                    sx={{
                                        width: '150px'
                                    }}
                                    rules={{
                                        required: ' Required',
                                        minLength: {
                                            value: 5,
                                            message: 'Minimun length 5'
                                        }
                                    }}
                                    maxDate={form.watch('endDateValue')}
                                />
                                <Typography variant="body1" sx={{ margin: '0 10px' }}>
                                    to
                                </Typography>
                                <MaterialUIPickers
                                    size="small"
                                    views={['year', 'month', 'day']}
                                    name="endDateValue"
                                    placeholder=" Enter Database Column Name"
                                    sx={{
                                        width: '150px'
                                    }}
                                    rules={{
                                        required: ' Required',
                                        minLength: {
                                            value: 5,
                                            message: 'Minimun length 5'
                                        }
                                    }}
                                    minDate={form.watch('startDateValue')}
                                />
                            </Box>
                        </Box>
                        <Box>
                            <FormHeadFilter headText="Mode of Payment" />
                            <MySelect
                                fullWidth
                                size="small"
                                name="modeOfPayment"
                                sx={{ minWidth: '130px' }}
                                rules={{
                                    required: 'Required !'
                                }}
                                items={[...modeOfPaymentArray12]}
                            />
                        </Box>
                        <Box>
                            <FormHeadFilter headText="currency Type " />
                            <MyTextField size="small" placeholder="Currency type" type="text" name="currency_type" rules={{}} />
                        </Box>
                    </Box>
                    <Box sx={{ width: '100%', textAlign: 'center', paddingBottom: '10px' }}>
                        <MyButton size="small" sx={{ marginRight: '15px' }} variant="contained" type="submit" startIcon={<SearchIcon />}>
                            Search
                        </MyButton>
                        <MyButton sx={{ marginRight: '15px' }} onClick={handleReset} size="small" color="error" variant="contained">
                            Reset
                        </MyButton>
                        <MyButton
                            variant="outlined"
                            size="small"
                            onClick={() => setCollapseFilterControl(false)}
                            startIcon={<CancelPresentationIcon color="error" />}
                        >
                            Close
                        </MyButton>
                    </Box>
                </form>
            </FormProvider>
        </Paper>
    );
};

///////Component Needed

const UpdatePaymentsForm = ({ formDefaultData, closePopup }) => {
    const dispatch = useDispatch();
    const {
        selectClientArray,
        statusFilertClientArray,
        modeOfPaymentArray,
        row,
        pageSize,
        pageIndex,
        sortedSelectClientArray,
        statusFilertInvoiceArray,
        selectInvoiceArray
    } = formDefaultData;
    const createPrams = useSelector(createPramsPaymentSelector);
    const singlepaymentDetail = useSelector(singleClientPaymentsDetailSelector);
    const lenval = singlepaymentDetail.length;

    const pathname = useLocation().pathname;
    const [clientDataOnSelect, setClientDataOnSelect] = React.useState(
        row?.currency_type ? { currency_type: row.currency_type, exchange_rate: row?.exchange_rate } : {}
    );
    const [fieldAmount, setFieldAmount] = React.useState(row?.amount ? Number(row.amount) : '');
    const [fieldAmountInr, setFieldAmountInr] = React.useState(row?.amount_in_inr ? Number(row.amount_in_inr) : '');
    const [amountError, setAmountError] = React.useState(false);
    const [amDeError, setAmDeError] = React.useState(false);
    const [exchange_rate, setExchange_rate] = React.useState(row?.exchange_rate ? row?.exchange_rate : '');

    const [tableFormData, setTableFormData] = React.useState([]);

    React.useEffect(() => {
        if (createPrams) {
            return navigate(`${pathname}/${createPrams}/add-payment`);
        }
    }, [createPrams]);

    // Function to calculate total amount in INR
    const calculateTotalAmountInINR = () => {
        const totalInINR = (fieldAmount * exchange_rate).toFixed(2);
        setFieldAmountInr(totalInINR);
    };

    React.useEffect(() => {
        calculateTotalAmountInINR();
    }, [fieldAmount, exchange_rate]);

    ////Effect
    React.useEffect(() => {
        // if (clientDataOnSelect?.currency_type === 'INR') {
        //     // setExchange_rate(1);
        // } else if (!row?.client_id && clientDataOnSelect?.currency_type !== 'INR') {
        // }
        setExchange_rate(clientDataOnSelect?.exchange_rate);
    }, [clientDataOnSelect]);

    React.useEffect(() => {
        dispatch(startClientPaymentsDataNoLoad(row?.id));
    }, []);

    const handleChangeExchnage = (event) => {
        setExchange_rate(event.target.value);
    };
    const handleChangeAmount = (event) => {
        if (fieldAmount > row?.amount && lenval > 0) {
            setAmDeError(false);
        }
        if (event.target.value > 0) {
            setAmountError(false);
            setAmDeError(false);
        } else {
            setAmountError(true);
            setAmDeError(true);
        }
        setFieldAmount(event.target.value);
    };

    //Form
    const form = useForm({
        defaultValues: row?.client_id
            ? { ...row }
            : {
                  client_id: '',
                  added_by: '',
                  reference: '',
                  payment_mode: '',
                  amount: '',
                  amount_in_inr: '',
                  remarks: '',
                  invoice_payments: ''
              }
    });

    const navigate = useNavigate();

    const onSubmit = async (data) => {
        if (fieldAmount === '' || fieldAmount < 1) {
            setAmountError(true);
            return;
        }

        if (fieldAmount < row?.amount && lenval > 0) {
            setAmDeError(true);
            return;
        } else if (lenval === 0 && fieldAmount < row?.amount) {
            setAmDeError(false);
        }

        const isValid = await form.trigger();
        if (isValid) {
            dispatch(
                startAddNewPayment({
                    data: {
                        ...data,
                        added_by: 1,
                        amount: fieldAmount,
                        currency_type: clientDataOnSelect?.currency_type,
                        exchange_rate,
                        status: 1,
                        amount_in_inr: fieldAmountInr,
                        invoice_payments: tableFormData
                    }
                })
            );

            form.reset({
                client_id: '',
                added_by: '',
                reference: '',
                payment_mode: '',
                amount: '',
                amount_in_inr: '',
                remarks: '',
                invoice_payments: ''
            });
        }
        if (row?.id) {
            navigate(`${pathname}/${row.id}/add-payment`);
        }
    };

    const [tableData, setTableData] = React.useState([]);
    const [tableInvData, setTableInvData] = React.useState([]);

    const onSelectClient = (id) => {
        setClientDataOnSelect(statusFilertClientArray.find((item) => item.id === id));
        const mappedData = {
            pageSize: 40,
            pageIndex: 1,
            clientName: statusFilertClientArray.find((item) => item.id === id).name,
            invoiceStatus: -1,
            invoiceNumber: '',
            startDateValue: '2023-6-18',
            endDateValue: new Date()
        };
        dispatch(startFilterInvoicesListData(mappedData));
    };
    const tableCellStyle = {
        borderRight: '1px solid rgba(224, 224, 224, 1)',
        borderTop: '1px solid rgba(224, 224, 224, 1)',
        padding: '5px'
    };
    const tableCellStyleTwo = {
        borderRight: '1px solid rgba(224, 224, 224, 1)',
        padding: '10px'
    };

    return (
        <>
            <Box>
                <FormProvider {...form}>
                    <form onSubmit={form.handleSubmit(onSubmit)}>
                        <Grid container sx={{ p: '20px' }} columnSpacing={1}>
                            <Grid item sm={4} xs={12}>
                                <Grid container columnSpacing={1}>
                                    <Grid item xs={12} sm={12}>
                                        <Box sx={{ display: 'flex', width: '100%' }}>
                                            <FormHead
                                                sx={{ whiteSpace: 'nowrap', paddingTop: '15px' }}
                                                headText={`Select Client`}
                                                required={true}
                                            />
                                            {row?.client_name ? (
                                                <TextField
                                                    value={row?.client_name}
                                                    size="small"
                                                    type="text"
                                                    // name="name"
                                                    placeholder=" Auto Fill "
                                                    sx={{
                                                        width: '60%',
                                                        paddingBottom: '25px'
                                                    }}
                                                    InputProps={{
                                                        readOnly: true
                                                    }}
                                                />
                                            ) : (
                                                <MySelect
                                                    fullWidth
                                                    size="small"
                                                    name="client_id"
                                                    sx={{ width: '60%' }}
                                                    info={{
                                                        handlePaymentBy: onSelectClient
                                                    }}
                                                    rules={{
                                                        required: 'Required !'
                                                    }}
                                                    items={[...sortedSelectClientArray]}
                                                />
                                            )}
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Box sx={{ display: 'flex', width: '100%' }}>
                                            <FormHead headText={`Currency`} required={true} />
                                            <TextField
                                                value={clientDataOnSelect?.currency_type}
                                                size="small"
                                                type="text"
                                                name="name"
                                                placeholder=" Auto Fill "
                                                sx={{
                                                    width: '60%'
                                                }}
                                                InputProps={{
                                                    readOnly: true
                                                }}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={12} sx={{ paddingTop: '25px' }}>
                                        <Box sx={{ display: 'flex', width: '100%' }}>
                                            <FormHead headText={`Exchange Rate`} required={true} />

                                            <TextField
                                                value={exchange_rate}
                                                size="small"
                                                type="number"
                                                name="exchange"
                                                onChange={handleChangeExchnage}
                                                placeholder="Exchnage Rate"
                                                sx={{
                                                    width: '60%'
                                                }}
                                                InputProps={{
                                                    readOnly: clientDataOnSelect?.currency_type === 'INR' ? true : false
                                                }}
                                                required={true}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item sm={4} xs={12}>
                                <Grid container columnSpacing={2}>
                                    <Grid item xs={12} sm={12} sx={{ paddingTop: '0px' }}>
                                        <FormControl error={amountError} fullWidth>
                                            <Box sx={{ display: 'flex', width: '100%' }}>
                                                <FormHead
                                                    sx={{ whiteSpace: 'nowrap', paddingTop: '15px' }}
                                                    headText={`Amount`}
                                                    required={true}
                                                />
                                                <TextField
                                                    name="amount"
                                                    value={fieldAmount}
                                                    onChange={handleChangeAmount}
                                                    sx={{ width: '60%' }}
                                                    id="formatted-numberformat-input"
                                                    error={amountError || amDeError}
                                                    size="small"
                                                    rules={{
                                                        required: 'Required !'
                                                    }}
                                                    type="number"
                                                />
                                            </Box>
                                            <FormHelperText sx={{ marginLeft: '150px' }}>
                                                {amountError && 'Amount must be grater then 0.'}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={12} sm={12} sx={{ paddingTop: '25px' }}>
                                        <Box sx={{ display: 'flex', width: '100%' }}>
                                            <FormHead
                                                sx={{ whiteSpace: 'nowrap', paddingTop: '15px' }}
                                                headText={`Amount in INR`}
                                                required={true}
                                            />
                                            <TextField
                                                name="amount_in_inr"
                                                value={fieldAmountInr}
                                                sx={{ width: '60%' }}
                                                id="formatted-numberformat-input"
                                                error={amountError}
                                                InputProps={{
                                                    readOnly: true,
                                                    inputComponent: NumberFormatCustom
                                                }}
                                                size="small"
                                                type="text"
                                                inputProps={{
                                                    step: 'any',
                                                    min: 0
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item sm={4} xs={12}>
                                <Grid container columnSpacing={2}>
                                    <Grid item xs={12} sm={12} sx={{ paddingTop: '0px' }}>
                                        <Box sx={{ display: 'flex', width: '100%' }}>
                                            <FormHead
                                                sx={{ whiteSpace: 'nowrap', paddingTop: '0px' }}
                                                headText={`Mode of Pay`}
                                                required={true}
                                            />
                                            <MySelect
                                                fullWidth
                                                size="small"
                                                name="payment_mode"
                                                sx={{ width: '60%' }}
                                                items={[...modeOfPaymentArray]}
                                                rules={{
                                                    required: 'Required !'
                                                }}
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} sm={12} sx={{ paddingTop: '0px' }}>
                                        <Box sx={{ display: 'flex', width: '100%' }}>
                                            <FormHead
                                                sx={{ whiteSpace: 'nowrap', paddingTop: '15px' }}
                                                headText={`Reference`}
                                                required={true}
                                            />
                                            <MyTextField
                                                sx={{ width: '60%' }}
                                                size="small"
                                                type="text"
                                                name="reference"
                                                rules={{
                                                    required: ' Required'
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {tableInvData.length > 0 && (
                                <Grid item xs={12} sm={12} sx={{ paddingTop: '24px' }}>
                                    <Box sx={{ display: 'flex', width: '100%' }}>
                                        {/* Table Headings */}
                                        <TableContainer sx={{ marginBottom: '17px', marginLeft: '20px', marginRight: '10px' }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell
                                                            sx={{
                                                                borderRight: '1px solid rgba(224, 224, 224, 1)',
                                                                borderTop: '1px solid rgba(224, 224, 224, 1)',
                                                                borderLeft: '1px solid rgba(224, 224, 224, 1)'
                                                            }}
                                                        >
                                                            S No.
                                                        </TableCell>
                                                        <TableCell style={tableCellStyle}>Invoice Number</TableCell>
                                                        <TableCell style={tableCellStyle}>Invoice Amount</TableCell>
                                                        <TableCell style={tableCellStyle}>Due Amount</TableCell>
                                                        <TableCell style={tableCellStyle}>Splitted Amount</TableCell>

                                                        {clientDataOnSelect?.currency_type === 'USD' && (
                                                            <TableCell style={tableCellStyle}>Splitted Amount(INR)</TableCell>
                                                        )}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {/* Map through your API data to render rows */}
                                                    {tableInvData.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell
                                                                sx={{
                                                                    borderRight: '1px solid rgba(224, 224, 224, 1)',
                                                                    borderLeft: '1px solid rgba(224, 224, 224, 1)'
                                                                }}
                                                            >
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell style={tableCellStyleTwo}>{row.invoice_number}</TableCell>
                                                            <TableCell style={tableCellStyleTwo}>{row.total_amount}</TableCell>
                                                            <TableCell style={tableCellStyleTwo}>{row.total_amount}</TableCell>
                                                            <TableCell style={tableCellStyleTwo}>
                                                                <TextField fullWidth size="small" type="number" />
                                                            </TableCell>
                                                            {clientDataOnSelect?.currency_type === 'USD' && (
                                                                <TableCell style={tableCellStyleTwo}>
                                                                    {(tableFormData[index]?.splited_amount * exchange_rate).toFixed(2) ===
                                                                    'NaN'
                                                                        ? 0
                                                                        : (tableFormData[index]?.splited_amount * exchange_rate).toFixed(
                                                                              2
                                                                          ) || '0'}
                                                                </TableCell>
                                                            )}
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>
                                </Grid>
                            )}

                            <Grid item xs={12} sm={12} sx={{ paddingTop: '24px' }}>
                                <Box sx={{ display: 'flex', width: '100%' }}>
                                    <Box sx={{ marginRight: '70px' }}>
                                        <FormHead sx={{ whiteSpace: 'nowrap', paddingTop: '5px' }} headText={`Remarks`} required={true} />
                                    </Box>

                                    <MyTextField
                                        multiline
                                        rows={2}
                                        sx={{ width: '80%' }}
                                        size="small"
                                        type="text"
                                        name="remarks"
                                        rules={{
                                            required: ' Required'
                                        }}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <MyButton type="submit" startIcon={<CheckIcon />} size="small" variant="contained" color="success">
                                    Save and Continue
                                </MyButton>
                                <MyButton
                                    onClick={closePopup}
                                    startIcon={<ClearAll />}
                                    size="small"
                                    variant="contained"
                                    color="error"
                                    sx={{ marginLeft: '10px' }}
                                >
                                    Close
                                </MyButton>
                            </Grid>
                        </Grid>
                    </form>
                </FormProvider>
            </Box>
        </>
    );
};

//Action Column
const ActionColumn = ({ row, onClickView, onClickEdit, pageIndex, pageSize }) => {
    const dispatch = useDispatch();
    const allClientData = useSelector(allClientsDataSelector);
    const { lookupDetailForId1 } = useSelector(lookUpDetailByIdSelector);
    const statusFilertClientArray = allClientData.filter((item) => Boolean(item.status));
    const selectClientArray = statusFilertClientArray.map((item) => {
        return {
            name: item.name,
            value: item.id
        };
    });

    const modeOfPaymentArray = lookupDetailForId1.map((item) => {
        return {
            name: item.name,
            value: item.id
        };
    });

    const sortedSelectClientArray = [...selectClientArray];
    sortedSelectClientArray.sort((a, b) => {
        const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });
    const navigate = useNavigate();
    const pathName = useLocation().pathname;
    const locationName = useLocation().pathname;
    const [popUpOpen, setPopUpOpen] = React.useState(false);
    const [popUpOpen2, setPopUpOpen2] = React.useState(false);
    function closePopup() {
        setPopUpOpen2(false);
        setPopUpOpen(false);
    }

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'space-around'
            }}
        >
            <IconButton onClick={() => navigate(`${pathName}/${row.id}/receipt-details`)} title="View Details" size="small">
                <VisibilityOutlinedIcon color="primary" />
            </IconButton>

            {Boolean(row.status) ? (
                <IconButton
                    onClick={() => {
                        dispatch(setCreatePrams(null));
                        setPopUpOpen2(true);
                    }}
                    color="primary"
                    title="Edit Payments"
                    size="small"
                >
                    <Edit />
                </IconButton>
            ) : (
                <IconButton disabled title="Disabled" size="small">
                    <Edit />
                </IconButton>
            )}

            {Boolean(row.status) ? (
                <IconButton
                    aria-label="delete"
                    title="Delete Payment"
                    onClick={() => {
                        setPopUpOpen(true);
                    }}
                >
                    <DeleteIcon color="error" />
                </IconButton>
            ) : (
                <IconButton disabled title="Disabled" size="small">
                    <DeleteIcon />
                </IconButton>
            )}
            <PopupDialogs title={'API'} needTitleBar={false} size="sm" open={popUpOpen} setOpen={closePopup}>
                {popUpOpen && (
                    <DeletePopup
                        onClickNo={() => setPopUpOpen(false)}
                        onClickYes={() => {
                            closePopup();
                            dispatch(
                                startDeletePayment({
                                    data: row.id,
                                    tableData: {
                                        pageSize,
                                        pageIndex: Number(pageIndex) + 1
                                    }
                                })
                            );
                        }}
                    />
                )}
            </PopupDialogs>
            <PopupDialogs title={'Edit Payment'} needTitleBar={true} size="lg" open={popUpOpen2} setOpen={closePopup}>
                {popUpOpen2 && (
                    <UpdatePaymentsForm
                        formDefaultData={{
                            row,
                            statusFilertClientArray,
                            selectClientArray,
                            modeOfPaymentArray,
                            pageIndex,
                            pageSize,
                            sortedSelectClientArray
                        }}
                        closePopup={closePopup}
                    />
                )}
            </PopupDialogs>
        </Box>
    );
};

////Main Componet
const ManagePayments = ({ isLoadingPaymentData, pageIndex, pageSize, setPageIndex, setPageSize }) => {
    const dispatch = useDispatch();
    const pathName = useLocation().pathname;
    const navigate = useNavigate();
    ///Selector
    const allClientData = useSelector(allClientsDataSelector);
    const paymentsData = useSelector(allPaymentsDataSelector);
    const { lookupDetailForId1 } = useSelector(lookUpDetailByIdSelector);

    const allInvoiceData = useSelector(allInvoicesSelector);

    const statusFilertInvoiceArray = allInvoiceData[0]?.filter((item) => Boolean(item.status));

    const selectInvoiceArray = statusFilertInvoiceArray?.map((item) => {
        return {
            name: item.invoice_number,
            value: item.invoice_number
        };
    });

    const statusFilertClientArray = allClientData.filter((item) => Boolean(item.status));
    const selectClientArray = statusFilertClientArray.map((item) => {
        return {
            name: item.name,
            value: item.id
        };
    });
    //

    const modeOfPaymentArray = lookupDetailForId1.map((item) => {
        return {
            name: item.name,
            value: item.id
        };
    });
    const sortedSelectClientArray = [...selectClientArray];
    sortedSelectClientArray.sort((a, b) => {
        const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
        const nameB = b.name.toUpperCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });
    ///State
    const [collapseFilterControl, setCollapseFilterControl] = React.useState(false);
    const [filterStatus, setFilterStatus] = React.useState(false);
    const [filteredRows, setFilteredRows] = React.useState([]);

    ///
    const [popUpOpen, setPopUpOpen] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [rowsCount, setRowsCount] = React.useState(0);
    ///
    ///Fetch Data
    const fildata = useSelector(FilterDataSelector);
    const fecthDataDispatch = () => {
        if (fildata.clientName || fildata.payment_mode || fildata.reference || fildata.startDateValue) {
            const mapobj = {
                clientName: fildata.clientName,
                payment_mode: fildata.payment_mode,
                reference: fildata.reference,
                startDateValue: fildata.startDateValue,
                endDateValue: fildata.endDateValue
            };

            // Dispatch filtered data with pagination information
            dispatch(startFilterpaymentsListData(mapobj));
        } else {
            // Dispatch pagination data without filter information
            dispatch(startPaymentListByPageIndex());
        }
    };
    ///

    React.useEffect(() => {
        if (paymentsData && paymentsData.length > 0) {
            setFilteredRows(paymentsData[0]);
            setData(paymentsData[0]);
            setRowsCount(paymentsData[1][0]?.total_count);
        }
    }, [paymentsData]);
    React.useEffect(() => {
        if (data?.length === 0) {
            dispatch(
                startPaymentListByPageIndex({
                    pageSize,
                    pageIndex: pageIndex + 1
                })
            );
        }
    }, [pageIndex, pageSize]);

    //
    //Use Effect
    React.useEffect(() => {
        dispatch(startAllClientsData());
        dispatch(startLookUpDetailsByLookupId1(11));
        dispatch(setCreatePrams(null));
    }, []);
    //

    React.useEffect(() => {
        setFilteredRows(paymentsData);
    }, [paymentsData]);
    ////
    function closePopup() {
        setPopUpOpen(false);
    }
    const headCells = [
        { label: 'S No.', id: 'id' },
        {
            id: 'client_name',
            label: 'Client'
        },
        {
            id: 'currency_type',
            label: 'Currency'
        },
        {
            id: 'mode_of_pay',
            label: 'Mode of Payment',
            align: 'right'
        },
        {
            id: 'amount',
            label: 'Amount',
            align: 'right'
        },
        {
            id: 'added_date',
            label: 'Date ',
            align: 'center'
        },
        {
            id: 'status',
            label: 'Status'
        },
        {
            id: 'action',
            label: 'Action',
            align: 'center'
        }
    ];

    return (
        <Box>
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'end'
                }}
            >
                <Box sx={{ display: 'flex', marginBottom: '25px' }}>
                    <Box sx={{ marginRight: '15px' }}>
                        <Badge color="secondary" variant={filterStatus ? 'dot' : 'standard'}>
                            <MyButton
                                size="small"
                                startIcon={<FilterAltIcon />}
                                variant="contained"
                                onClick={() => setCollapseFilterControl(!collapseFilterControl)}
                            >
                                Filter
                            </MyButton>
                        </Badge>
                    </Box>
                    <Box>
                        <Box sx={{ textAlign: 'right', paddingRight: '25px' }}>
                            <Box sx={{ width: '100%', textAlign: 'right' }}>
                                <MyButton
                                    size="small"
                                    variant="contained"
                                    onClick={() => {
                                        dispatch(setCreatePrams(null));
                                        setPopUpOpen(true);
                                    }}
                                    title="Add Payments "
                                >
                                    + Add
                                </MyButton>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>

            <SimpleCollapse
                infoData={{
                    setCollapseFilterControl,
                    filterStatus,
                    setFilterStatus,
                    setFilteredRows,
                    selectClientArray,
                    sortedSelectClientArray,
                    rows: paymentsData,
                    modeOfPaymentArray
                }}
                control={collapseFilterControl}
                CollapseComponent={FilterAndSearchBox}
            />

            <Paper>
                <PaymentTable
                    headCells={headCells}
                    isLoading={isLoadingPaymentData}
                    loadingMessage={'Loading please wait'}
                    ActionComponent={ActionColumn}
                    data={data}
                    dispatchAPI={fecthDataDispatch}
                    rowsCount={rowsCount}
                    setRowsCount={setRowsCount}
                    pathName={pathName}
                    pageSize={pageSize}
                    pageIndex={pageIndex}
                    setPageSize={setPageSize}
                    setPageIndex={setPageIndex}
                />
            </Paper>
            <PopupDialogs title={'Add New Payment'} needTitleBar={true} size="lg" open={popUpOpen} setOpen={setPopUpOpen}>
                <UpdatePaymentsForm
                    formDefaultData={{
                        statusFilertClientArray,
                        selectClientArray,
                        pageSize,
                        pageIndex,
                        modeOfPaymentArray,
                        sortedSelectClientArray,
                        statusFilertInvoiceArray,
                        selectInvoiceArray
                    }}
                    closePopup={closePopup}
                />
            </PopupDialogs>
        </Box>
    );
};
export default ManagePayments;
